import { history } from 'store/configureStore';
import { getCurrentLanguage } from 'modules/language/selectors/language';

export const redirectTo = path => {
  const nextPath = `/${ getCurrentLanguage() + path }`;
  const currentPath = history.location.pathname + history.location.search;
  if (currentPath !== nextPath) history.push(nextPath);
};
export const replaceTo = path => {
  const nextPath = `/${ getCurrentLanguage() + path }`;
  const currentPath = history.location.pathname + history.location.search;
  if (currentPath !== nextPath) history.replace(nextPath);
};

